import { useContext, useState, useEffect } from 'react'
import { AuthContext } from '../../context/auth'
import { SidebarContainer } from './style'
import { toAbsoluteUrl } from '../../utils/assetHelper'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { hasPermission, isAvailableRoute } from '../../utils/permissions'


const Index = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const { user, setLogOutModal, openDropDownAdmin, setOpenDropDownAdmin, openDropDownProducts,setOpenDropDownProducts } = useContext(AuthContext)
    const [openSidebar, setOpenSidebar] = useState(true)
    const userPermissions = user?.user?.teamRole

    const toggleProductsDropdown = () => {
        setOpenDropDownProducts(prev => {
            setOpenDropDownAdmin(false)
            return !prev
        });
    };

    const toggleAdminDropdown = () => {
        setOpenDropDownAdmin(prev => {
            setOpenDropDownProducts(false)
            return !prev
        });
    };

    useEffect(() => {
        if (openSidebar) {
            setOpenDropDownProducts(!pathname?.includes('admin'))
            setOpenDropDownAdmin(pathname?.includes('admin'))
        } else {
            setOpenDropDownProducts(false)
            setOpenDropDownAdmin(false)
        }
    }, [openSidebar])
    


    return (
        <SidebarContainer style={{ width: openSidebar ? '300px' : '90px' }}>
            <span className='close-sidebar' onClick={() => setOpenSidebar(!openSidebar)}>
                {openSidebar ? <i className="fal fa-angle-left" style={{ fontSize: '24px' }}></i> : <i className="fal fa-angle-right" style={{ fontSize: '24px' }}></i>}
            </span>
            <div className="links-wrapper">
                <img src={toAbsoluteUrl('/media/logoheader.png')} className='logo' alt="" loading='lazy' style={{ display: openSidebar ? 'block' : 'none' }} />
                <img src={toAbsoluteUrl('/media/sidebarlogo.png')} className='sidebar-logo' alt="" loading='lazy' style={{ display: !openSidebar ? 'block' : 'none' }} />

                <div className="links">
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/products', 'GET', user?.user?.id) && 
                    <button
                        className="link"
                        style={{
                            color: pathname.includes('products') && 'var(--primary-color)',
                            fontWeight: pathname.includes('products') && '700',
                            background: !openSidebar && pathname.includes('products') && '#fff2e5',
                            borderRadius: !openSidebar && '12px',
                            justifyContent: !openSidebar && 'center',
                        }}
                        onClick={() =>
                            openSidebar
                                ? toggleProductsDropdown()
                                : navigate('/products/primary-antibodies')
                        }
                    >
                        <i
                            className="fal fa-boxes"
                            style={{ color: pathname.includes('products') && 'var(--primary-color)' }}
                        ></i>
                        {openSidebar && `Products`}
                        {openSidebar && (openDropDownProducts ? (
                            <i className="fal fa-angle-down angle"></i>
                        ) : (
                            <i className="fal fa-angle-up angle"></i>
                        ))}
                    </button>
                    }
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/products', 'GET', user?.user?.id) &&
                    <div className={`sub-link ${openDropDownProducts ? 'sub-link-active' : ''}`}>
                        <NavLink to="/products/primary-antibodies" className="link">
                            Primary Antibodies
                        </NavLink>
                        <NavLink to="/products/alexa-fluor-primary" className="link">
                            Alexa Fluor™ Primary Antibodies
                        </NavLink>
                        <NavLink to="/products/alexa-fluor-secondary" className="link">
                            Alexa Fluor™ Secondary Antibodies
                        </NavLink>
                        <NavLink to="/products/templates" className="link">
                            Templates
                        </NavLink>
                        <NavLink to="/products/templates-category" className="link">
                            Templates Category
                        </NavLink>
                    </div>
                    }
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/inventory', 'GET', user?.user?.id) && <NavLink
                        to="/inventory"
                        className="link"
                        style={{ justifyContent: !openSidebar && 'center' }}
                    >
                        <i className="fal fa-box-open"></i>
                        {openSidebar && `Inventory`}
                    </NavLink>
                    }
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/thermofisher', 'GET', user?.user?.id) &&
                    <NavLink
                        to="/thermofisher"
                        className="link"
                        style={{ justifyContent: !openSidebar && 'center' }}
                    >
                        <i className="fal fa-link"></i>
                        {openSidebar && `Thermofisher`}
                    </NavLink>
                    }
                     {hasPermission(userPermissions?.permissions[0]?.metadata, '/customers', 'GET', user?.user?.id) && 
                    <NavLink
                        to="/customers"
                        className="link"
                        style={{ justifyContent: !openSidebar && 'center'}}
                    >
                        <i className="fal fa-users"></i> {openSidebar && `Customers`}
                    </NavLink>
                    }
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/orders', 'GET', user?.user?.id) && 
                    <NavLink
                        to="/order-history"
                        className="link"
                        style={{ justifyContent: !openSidebar && 'center' }}
                    >
                        <i className="fal fa-clipboard-check"></i>
                        {openSidebar && `Order History`}
                    </NavLink>
                    }
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/teams', 'GET', user?.user?.id) && 
                    <NavLink
                        to="/team-bio"
                        className="link"
                        style={{ justifyContent: !openSidebar && 'center' }}
                    >
                        <i className="fal fa-id-badge"></i>
                        {openSidebar && `Team Bios`}
                    </NavLink>
                    }
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/users', 'GET', user?.user?.id) && 
                    <button
                        className="link"
                        style={{
                            color: pathname.includes('admin') && 'var(--primary-color)',
                            fontWeight: pathname.includes('admin') && '700',
                            background: !openSidebar && pathname.includes('admin') && '#fff2e5',
                            borderRadius: !openSidebar && '12px',
                            justifyContent: !openSidebar && 'center',
                        }}
                        onClick={() =>
                            openSidebar ? toggleAdminDropdown() : navigate('/admin/users')
                        }
                    >
                        <i
                            className="fal fa-user-shield"
                            style={{ color: pathname.includes('admin') && 'var(--primary-color)' }}
                        ></i>
                        {openSidebar && `Admins`}
                        {openSidebar && (openDropDownAdmin ? (
                            <i className="fal fa-angle-down angle"></i>
                        ) : (
                            <i className="fal fa-angle-up angle"></i>
                        ))}
                    </button>
                    }
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/users', 'GET', user?.user?.id) && 
                    <div className={`sub-link ${openDropDownAdmin ? 'sub-link-active' : ''}`}>
                        <NavLink to="/admin/users" className="link">
                            <i className='fal fa-user'/> Users
                        </NavLink>
                        <NavLink to="/admin/roles" className="link">
                            <i className="fal fa-key" />Roles
                        </NavLink>
                    </div>
                    }
                    {hasPermission(userPermissions?.permissions[0]?.metadata, '/analytics', 'GET', user?.user?.id) &&
                    <NavLink to="/analytics" className={'link'} style={{justifyContent: !openSidebar && 'center'}}><i class="fal fa-chart-bar"></i>{openSidebar && `Analytics`}</NavLink>
                    }
                </div>
            </div>
            <div className="profile-wrapper">
                <div className="profile" style={{ justifyContent: !openSidebar && 'center' }}>
                <span>{user?.user?.first_name ? user?.user?.first_name[0] : 'A'}</span>
                {openSidebar && user?.user?.first_name ? user?.user?.first_name : openSidebar && 'Admin'}{' '}
                {openSidebar && user?.user?.last_name ? user?.user?.last_name : openSidebar && 'User'}
                </div>
                <button className='profile' style={{ color: '#DC1E00', fontWeight: '500', fontSize: '14px', justifyContent: !openSidebar && 'center' }}
                    onClick={() => { setLogOutModal(true) }}
                >
                    <i className="fal fa-sign-out" style={{ fontSize: '16px', fontWeight: '300' }}></i> {openSidebar && 'Sign Out'}
                </button>
            </div>
        </SidebarContainer>
    )
}

export default Index